import Api from '@/services/Index';
const agingSummaryReport = async (config) => {
    return Api.get('/housing/reservation/payments/aging-summary-report', config);
}
const AvailabilityTenantInformationReport = async (config) => {
    return Api.get('/housing/tenants/information-report', config);
}
const workOrderMaintenanceRequestReport = async (config) => {
    return Api.get('/housing/requests/work-order-request-report', config);
}
const HousingBankReconciliation  = async (config) => {
    return Api.get(`/housing/reservation/payments/bank-reconciliation-report`, config);
}
const housingCashFlowReport  = async (config) => {
    return Api.get(`/housing/reservation/payments/cash-flow-report`, config);
}

const housingCollectionReport  = async (config) => {
    return Api.get(`/housing/reservation/payments/collection-report`, config);
}

export default {
    agingSummaryReport,
    AvailabilityTenantInformationReport,
    workOrderMaintenanceRequestReport,
    HousingBankReconciliation,
    housingCashFlowReport,
    housingCollectionReport
}

